export const PASSWORD_SPECIAL_CHARS = `!"#$%€&'()*+,-./:;<=>?@[\\]^_'{|}~`;
export const MIN_PASSWORD_LENGTH = 8;

const charSet = new Set(PASSWORD_SPECIAL_CHARS);

export function hasSpecialChar(value: string) {
  for (const char of value) {
    if (charSet.has(char)) {
      return true;
    }
  }
  return false;
}

export function hasLowercaseChar(value: string) {
  return /[a-z]/.test(value);
}

export function hasUppercaseChar(value: string) {
  return /[A-Z]/.test(value);
}

export function hasNumber(value: string) {
  return /\d/.test(value);
}

export function hasMinLength(value: string) {
  return value.length >= MIN_PASSWORD_LENGTH;
}

export function getBadChars(value: string) {
  const badChars = new Set();
  for (const char of value) {
    if (charSet.has(char)) {
      continue;
    }
    if (/[a-zA-Z\d]/.test(char)) {
      continue;
    }
    badChars.add(char);
  }
  return Array.from(badChars);
}

export function hasNoBadChars(value: string) {
  return getBadChars(value).length === 0;
}

export function isStrongPassword(value: string) {
  return (
    // hasSpecialChar(value) &&
    hasLowercaseChar(value) &&
    hasUppercaseChar(value) &&
    hasNumber(value) &&
    hasMinLength(value) &&
    hasNoBadChars(value)
  );
}

export const isStrictEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
